import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: 'kpiDocumentsToCount',
  standalone: true,
})
export class KpiDocumentsToCount implements PipeTransform {

  /**
   * Transforms document metric data row value into count by counting the number of documents.
   *
   * This transformer is used to:
   * - Parse document-type metric data row value
   * - Count the number of documents based on \n characters
   */
  transform(rowValue: string): string {
    const newlineCount = (rowValue.match(/\n/g) || []).length;
    return `${newlineCount} docs`;
  }
}
